<template>
  <div class="page">
    <div class="body center">
      <img class="mt100"
        src="../../src/assets/img/ykfpay/ykficon.png">
      <p class="color_fff fs20 pt20 pb100">医快付</p>
      <p class="font1 color_fff fs15">
        1.请下载“医快付”App支付处方费用（支持医保）<br/><br/>
        2.支付完成后返回“名医馆”，您可在“我的 处方”中选择“送药到家”，我们会为您快递药品上门
      </p>
      <div @click="toDownload"
        class="btn bg_fff color_main fs15 radius40 mt100">
        <p>点击下载“医快付”</p>
      </div>
    </div>
  </div>

</template>

<script>
    export default {
        name: 'ykfpay',
      methods: {
        toDownload () {
            window.location.href = '/online'
        }
      }
    }
</script>

<style scoped lang="scss">
  .body{
    background-image: url("../../src/assets/img/ykfpay/ykfback.png");
    width: 375*2px;
    height: 100vh;
    background-size: cover ;
    background-position: center bottom;
    background-repeat: no-repeat;
  }
  .btn{
    width: 220*2px;
    height: 45*2px;
    margin-left: 156px;
    margin-right: 156px;
    p{
      line-height: 45*2px;
    }
  }

  .font1{
    width: 324*2px;
    margin-left: 54px;
    margin-right: 54px;
    letter-spacing: 0;
    text-align: justify;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ykfpay.vue